import { render, staticRenderFns } from "./Sticks.vue?vue&type=template&id=03b73d78&"
import script from "./Sticks.vue?vue&type=script&lang=js&"
export * from "./Sticks.vue?vue&type=script&lang=js&"
import style0 from "./Sticks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports